import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useCachedTable} from 'src/hooks/common-data-service/cached-table';
import {getAccountName} from 'src/openapi/admin/apis/GetAccountNameApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    accountSearchResultParentAccountsActions,
    accountSearchResultParentAccountsDataSelector,
    accountSearchResultParentAccountsResultSelector,
} from '../slices/account-search-result-parent-accounts.slice';
import {accountSearchResultStateSelector} from '../slices/account-search-result-state.slice';

import type {AccountSearchResultCacheKeys} from '../typedef';

type Props = {
    parentAccountIds: number[],
    totalCount: number,
};

export const useGetAccountSearchResultParentAccounts = ({parentAccountIds, totalCount}: Props) => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const getAction = useCallback(() => apiDispatch(getAccountName({
        requestBody: [...new Set(parentAccountIds)],
    })), [parentAccountIds, apiDispatch]);

    const setLoadedData = useCallback((
        response: Record<string, string>,
        dataCacheKeys: AccountSearchResultCacheKeys,
    ) => {
        dispatch(accountSearchResultParentAccountsActions.onSuccess(({
            cacheKeys: dataCacheKeys,
            totalCount,
            data: response,
        })));
    }, [totalCount, dispatch]);

    return useCachedTable({
        dataSelector: accountSearchResultParentAccountsDataSelector,
        stateSelector: accountSearchResultStateSelector,
        resultSelector: accountSearchResultParentAccountsResultSelector,
        actions: accountSearchResultParentAccountsActions,
        getAction,
        onSuccessLoad: setLoadedData,
        shouldClearOnUnmount: false,
    });
};
